import Button from "@mui/material/Button"

interface GoogleLoginButtonProps
{
  onClick: () => void
  text: string
  disabled: boolean
}

export const GoogleLoginButton = ({ onClick, text, disabled }: GoogleLoginButtonProps) => {
  return (<Button fullWidth disabled={disabled} onClick={onClick} variant="outlined">
    <img src={require("../assets/google.png")} style={styles.icon}/>
    {text}
  </Button>)
}

const styles = {
  button: {

  },
  icon: {
    objectFit: "contain" as "contain",
    width: 25,
    height: 25,
  }
}